import {
  AnimationTriggerMetadata,
  trigger,
  state,
  animate,
  style,
  transition,
  query,
  group,
  keyframes,
} from '@angular/animations';

// TODO: not currently used.
export const PgRadioAnimations: {
  readonly transitionSelection: AnimationTriggerMetadata;
} = {
  transitionSelection: trigger('transitionSelection', [
    state(
      'idle',
      style({
        'border-color': '#C4CDD5',
      })
    ),
  ]),
};
